import * as React from "react";
import { Alert, Button, Table, Tag, Typography } from "antd";
import { useTranslation } from "react-i18next";
import { getLocaleDatePicker } from "../../../utils/datePicker";
import { PickerLocale } from "antd/lib/date-picker/generatePicker";
import "./remunerationSummary.sass";
import { useAdvancedRetribution } from "src/api/api";
import moment from "moment";
import { UserContext } from "src/hooks/context/userInfo";
const { Title } = Typography;
export const TagsInfo = (param: TagsInfoProps) => {

  const { list } = param;

  const [showAll, setShowAll] = React.useState<boolean>(false);

  return (
    <>
      {
        list?.map((value, index) => {
          if (showAll || index < 5) {
            return <Tag key={index} className="channel-tag">{value}</Tag>
          }
        })
      }
      {
        list?.length > 5 ?
          <Button style={{ display: "block" }} size="small" type="primary" className="primary" onClick={() => {
            setShowAll(!showAll);
          }}>
            {
              showAll ? '-' : '+'
            }
          </Button> :
          <></>
      }
    </>
  )
}
// Componente Table personalizado para mostrar en la tabla el detalle de las remuneraciones
const RemunerationSummary = (param) => {
  const { t } = useTranslation("remuneration");
  const userData = React.useContext(UserContext);

  const configurationId = param.selectedConfigId;
  const advancedRetribution = useAdvancedRetribution();
  const [modifiedRetribution, setModifiedRetribution] = React.useState();
  const local: PickerLocale = getLocaleDatePicker();

  React.useEffect(() => {
    if (advancedRetribution) {
  
      const filterData = advancedRetribution?.filter(t => t?.isActive &&
        (
          t?.advancedGroupsConfigurations.length > 0 &&
          t.advancedGroupsConfigurations.find((ac) => { return ac.id === configurationId && ac.selected }) !== undefined
        )
      );

      const newData = filterData.flatMap((ret) => {
        const groupsAmount = ret?.advancedGroupsAmount.find((amount) => amount?.idCurrency === userData?.currency || amount?.amountType == 'percent');
        if (!groupsAmount) return [];

        var amount = groupsAmount?.amountType === 'fixed' ? `${groupsAmount?.amount} ${groupsAmount?.idCurrency}` : `${groupsAmount?.amount} %`;

        return [{
          name: ret?.name,
          configurations: ret?.advancedGroupsConfigurations?.filter((cfg, i) => cfg?.selected).map((tto) => tto?.name),
          channels: ret?.advancedGroupsTtoo?.filter((tto, i) => tto?.selected).map((tto) => tto?.name),
          rooms: ret?.advancedGroupsRoomTypes?.filter((room, i) => room?.selected).map((room) => room?.name),
          regimen: ret?.advancedGroupsRegimens?.filter((reg, i) => reg?.selected).map((reg) => reg?.name),
          quantities: amount,
          fromDate: ret.fromDate != null ? moment(new Date(ret.fromDate)).format(local.dateFormat) : t("summary.date-no-limits"),
          toDate: ret.toDate != null ? moment(new Date(ret.toDate)).format(local.dateFormat) : t("summary.date-no-limits"),
        }];
      });


      setModifiedRetribution(newData);
    }
  }, [advancedRetribution, configurationId]);



  const columns = [
    {
      title: t("summary.group"),
      dataIndex: "name",
      key: "name"
    },
    {
      title: t("summary.channel"),
      dataIndex: "channels",
      key: "channels",
      render: (a: any, b: any) => {
        return <TagsInfo list={a} />
      }
    },
    {
      title: t("summary.rooms"),
      dataIndex: "rooms",
      key: "rooms",
      render: (a: any, b: any) => {
        return <TagsInfo list={a} />;
      }
    },
    {
      title: t("summary.regimen"),
      dataIndex: "regimen",
      key: "regimen",
      render: (a: any, b: any) => {
        return <TagsInfo list={a} />;
      }
    },
    {
      title: t("summary.quantities"),
      dataIndex: "quantities",
      key: "quantities"
    },
    {
      title: t("summary.dates"),
      key: "dates",
      render: (_: any, record: any) => {
        return <div>
          <p className="ant-typography">{t("summary.from-date")}: {record.fromDate}</p>
          <p className="ant-typography">{t("summary.to-date")}: {record.toDate}</p>

        </div>;
      }
    },

  ];
  return (
    <>
      <div className="summary-remuneration row">
        <Title className="mt-4" level={4}>
          {t("summary.title")}
        </Title>
        <div className="col-md-1"></div>
        <div className="col-12">
          <Alert message={t("summary.notice")} type="info" showIcon style={{ marginBottom: "10px" }} closable />
        </div>
        <div className="col-12">
          <Table id="table-remuneration" columns={columns} dataSource={modifiedRetribution} pagination={false} />
        </div>
        <div className="col-md-1"></div>
      </div>
    </>
  );
};

interface TagsInfoProps {
  list: any[]
}


export default RemunerationSummary;
